import { RArray } from "../../../collections";
export class NullCrossSellingListProvider {
    items() {
        return RArray.empty();
    }
}
